import { requestApi } from './Api';

export const getProfessionGroups = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/practitioner/specialty/list',
    params
  });
};
